// ─────────────────────────────────────────────────────────────────────────────
// SurvAIHealth Metrics — Grievance data adapter (THE SEAM)
//
// Every grievance report reads through this one async function. In v1 it returns
// filtered mock records. When the real data-relay feed lands, ONLY this file
// changes — swap the mock source for a network/relay call and every report keeps
// calling getGrievances(...) unchanged.
//
//   getGrievances({ facilityCcn = "ALL", from = null, to = null })
//     facilityCcn : a CCN string, or "ALL" for the portfolio rollup
//     from / to   : optional ISO date bounds applied to dateReceived (inclusive)
//
// Keep this interface stable.
// ─────────────────────────────────────────────────────────────────────────────

import { GRIEVANCE_MOCK_RECORDS } from "./grievanceMockData";

function withinRange(iso, from, to) {
  if (!iso) return true; // never filter out a record for a missing date
  if (from && iso < from) return false;
  if (to && iso > to) return false;
  return true;
}

export async function getGrievances({ facilityCcn = "ALL", from = null, to = null } = {}) {
  // v1: synchronous mock, wrapped in a Promise so the call site is already async.
  // The real relay implementation will perform the network fetch here.
  const all = GRIEVANCE_MOCK_RECORDS;

  const filtered = all.filter((r) => {
    if (facilityCcn && facilityCcn !== "ALL" && r.facilityCcn !== facilityCcn) return false;
    if (!withinRange(r.dateReceived, from, to)) return false;
    return true;
  });

  // Return a defensive copy so reports can sort/mutate locally without
  // corrupting the shared mock source.
  return filtered.map((r) => ({ ...r }));
}
